export default "__VITE_ASSET__Cb9$WrvZ__"